/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BooleanInt64NullableKeyValuePair
 */
export interface BooleanInt64NullableKeyValuePair {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanInt64NullableKeyValuePair
     */
    key?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BooleanInt64NullableKeyValuePair
     */
    value?: number | null;
}

export function BooleanInt64NullableKeyValuePairFromJSON(json: any): BooleanInt64NullableKeyValuePair {
    return BooleanInt64NullableKeyValuePairFromJSONTyped(json, false);
}

export function BooleanInt64NullableKeyValuePairFromJSONTyped(json: any, ignoreDiscriminator: boolean): BooleanInt64NullableKeyValuePair {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function BooleanInt64NullableKeyValuePairToJSON(value?: BooleanInt64NullableKeyValuePair | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}


